// extracted by mini-css-extract-plugin
export default {"nextArrow":"SliderArrows_nextArrow__l0tnR","prevArrow":"SliderArrows_prevArrow__y06O4"};